import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, Button, Container, CssBaseline,
  TextField, Typography, FormControl,
  Card,
  CardContent
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Copyright from 'pages/components/Copyright';
import VenuxxBar from 'assets/venuxx-bar.jpg';
import EventList from 'pages/components/EventList';

// Actions
import { Creators } from 'store/ducks/tracking';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export const Index = (props, context) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { pending, error, data } = useSelector(state => state.tracking);
  const [orderId, setOrderId] = useState('');
  const [taskHistory, setTaskHistory] = useState([]);

  useEffect(() => {
    if (data?.task_history) {

      const normaliedData = normalizeTaskHistories(data?.task_history);
      setTaskHistory(normaliedData);
    }
  }, [data]);

  const normalizeTaskHistories = (data) => {
    const grupos = [];
    let grupoAtual = [];

    const getDescriptionType = (description) => {
      try {
        const parsed = JSON.parse(description);
        const { label } = parsed;
        return label || null;
      } catch {
        return null;
      }
    };

    const reduzirDescription = (description) => {
      try {
        const parsed = JSON.parse(description);
        const { fleet_data, input, label } = parsed;

        let newLabel = label;
        switch (label) {
          case 'message_response':
            newLabel = 'Mensagem'
            break;
          case 'Obs_adicional':
            newLabel = 'OBS. Adicional'
            break;
          case 'Observação_da_coleta':
            newLabel = 'OBS. Coleta'
            break;
          case 'Nome_do_recebedor':
          case 'Entregue_para':
          case 'Entregue_para:':
          case 'Recebido_por':
            newLabel = 'Recebido Por'
            break;
          case 'Responsável_do_despacho':
            newLabel = 'Despachado Por'
            break;
          case 'Quantidade_de_itens_coletados':
            newLabel = 'Itens Coletados'
            break;
          case 'Outras_Observações':
            newLabel = 'Outras OBS.'
            break;
        
          default:
            break;
        }

        return { fleet_data, input, label: newLabel };
      } catch {
        return description;
      }
    };

    const extrairLabelInterno = (labelDescription) => {
      if (!labelDescription) return null;
      const match = labelDescription.match(/<span[^>]*>(.*?)<\/span>/i);
      return match ? match[1] : null;
    };

    const extrairLabel = (item) => {
      try {
        const desc = JSON.parse(item.description);
        return desc.label || desc.display_name || null;
      } catch {
        return null;
      }
    };

    const obterChaveUnica = (item) => {
      if (item.type === 'custom_field_updated') {
        return extrairLabel(item);
      }
      return null;
    };

    const removerDuplicadosMaisAntigos = (grupo) => {

      const mapa = new Map();

      for (const item of grupo) {
        if (item?.fleet_id !== null) {
          const chave = obterChaveUnica(item);
          if (!chave) {
            mapa.set(Symbol(), item);
            continue;
          }

          if (!mapa.has(chave)) {
            mapa.set(chave, item);
          } else {
            const existente = mapa.get(chave);
            if (new Date(item.creation_datetime) > new Date(existente.creation_datetime)) {
              mapa.set(chave, item);
            }
          }
        }
      }

      const payload = Array.from(mapa.values()).map(item => (
        {
          id: item.id,
          creation_datetime: item.creation_datetime,
          description: reduzirDescription(item.description),
          type: getDescriptionType(item.description),
          label: extrairLabelInterno(item.label_description),
        }
      ));

      let result = payload.filter(item => (!["CREATED", "ACCEPTED", "ASSIGNED", "DELETED", "DECLINED"].includes(item.label) && String(item.description.label).toLowerCase() !== "code_response"))
      
      const detailExists = !!payload.find(item => String(item.type).toLowerCase() === "detalhe")
      
      if (detailExists) {
        result = result.filter(item => String(item.type).toLowerCase() !== "message_response")
      }      
      
      return result;
    };

    for (const item of data) {
      grupoAtual.push(item);

      if (
        item.label_description &&
        item.label_description.toUpperCase().includes("SUCCESSFUL")
      ) {
        const grupoFiltrado = removerDuplicadosMaisAntigos(grupoAtual);
        grupos.push(grupoFiltrado);
        grupoAtual = [];
      }
    }

    if (grupoAtual.length > 0) {
      const grupoFiltrado = removerDuplicadosMaisAntigos(grupoAtual);
      grupos.push(grupoFiltrado);
    }

    return grupos;
  };

  const handleSubmit = () => {
    if (error) {
      dispatch(Creators.cleanTracking());
      return false
    } else {
      if (orderId.trim().length > 0)
        dispatch(Creators.fetchTracking(orderId));
    }
  };

  const handleNewTracking = () => {
    dispatch(Creators.cleanTracking());
    setTaskHistory([]);
    setOrderId('');
  };

  return (
    <Container component="main" maxWidth="xl">
      <CssBaseline />
      <div className={classes.paper}>

        <Container style={{ paddingTop: '10px' }} maxWidth="sm">
          <div style={{ backgroundImage: `url(${VenuxxBar})`, width: '100%', height: '50px', backgroundRepeat: 'no-repeat', backgroundPosition: 'right', backgroundSize: 'cover' }} />

          {!data?.task_history &&
            <Card>
              <CardContent>
                <div className={classes.form} noValidate>
                  <form onSubmit={handleSubmit}>

                    {!error &&
                      <FormControl style={{ width: '100%' }}>
                        <TextField disabled={pending}
                          value={orderId}
                          onChange={e => setOrderId(e.target.value)}
                          variant="outlined"
                          margin="normal"
                          required
                          fullWidth
                          id="orderId"
                          label="Número do Rastreio"
                          name="orderId"
                          InputProps={{
                            style: { fontSize: '1.5rem', fontWeight:'bold' } // Fonte do input
                          }}
                          autoFocus
                        />
                      </FormControl>
                    }

                    <Button disabled={pending} style={{ backgroundColor: '#2f0145', color: '#FFFFFF' }}
                      fullWidth
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                      onClick={handleSubmit}
                    >
                      {pending ? 'rastreando...' : error ? 'RASTREAR OUTRO' : 'R A S T R E A R'}
                    </Button>
                  </form>

                  {
                    error &&
                    <div style={{ padding: '10px', backgroundColor: 'antiquewhite', marginTop: '20px', border: 'dashed', borderColor: '#999999', borderWidth: '1px', borderRadius: '5px', paddingLeft: '30px', paddingRight: '30px' }}>
                      <Typography style={{ color: '#2f0145', textAlign: 'center' }}>
                        O número de rastreio "{orderId}" não foi encontrado.
                      </Typography>
                    </div>
                  }
                </div>
              </CardContent>
            </Card>
          }
          {taskHistory && taskHistory.length > 0 &&
            <>
              <Card>
                <CardContent>
                  {
                    orderId &&
                    <Card>
                      <CardContent style={{backgroundColor:'#f1f1f1'}}>
                        <Typography variant='h5'>
                          Código: <span style={{ fontWeight: 'bold' }}>{orderId}</span>
                        </Typography>
                      </CardContent>
                    </Card>
                  }
                  <div style={{ paddingTop: 20 }}>

                    {
                      taskHistory.map((listaDeEventos, index) => (
                        <EventList data={listaDeEventos} jobType={data?.job_type} jobStatus={data?.job_status} key={`task_item_${index}`} />
                      ))
                    }
                    <Button disabled={pending} style={{ backgroundColor: '#2f0145', color: '#FFFFFF' }}
                      fullWidth
                      type="submit"
                      variant="contained"
                      color="secondary"
                      className={classes.submit}
                      onClick={handleNewTracking}
                    >
                      Rastrear outro pedido
                    </Button>
                  </div>

                </CardContent>
              </Card>
            </>
          }
        </Container>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

export default Index
